import AuthRoutes from "../components/pages/auth/AuthRoute";
import { APP_NAME } from "./constants";

export const flattenMenu = (menu: any[] = []) => {
  let result: any[] = [];

  menu.forEach((item) => {
    if (item.path || item.to) result.push(item);

    if (item.children) {
      result = result.concat(flattenMenu(item.children));
    }
  });

  return result;
};

// Flatten nested children routes
const flattenAuthRoutes = (routes: any[]): any[] => {
  let result: any[] = [];

  routes.forEach((route) => {
    // Include the current route if it has a path
    if (route.path) result.push(route);

    // If it has children, flatten them too
    if (route.children)
      result = result.concat(flattenAuthRoutes(route.children));
  });

  return result;
};

export const getPageTitle = (pathname: string) => {
  const flatRoutes = flattenAuthRoutes(AuthRoutes);

  // Find exact match
  const match = flatRoutes.find((route) => route.path === pathname);

  if (!match?.path) return APP_NAME;

  // Remove leading slash
  const pathWithoutSlash = match.path.replace(/^\/+/, "");

  // Capitalize first letter
  const title = pathWithoutSlash
    ? pathWithoutSlash.charAt(0).toUpperCase() + pathWithoutSlash.slice(1)
    : "";

  return `${title} | ${APP_NAME}`;
};
